module.exports = __webpack_public_path__ + "img/character_lineup_front.79517809.jpg";